export enum CreateRemixError {
  authentication,
  notFound,
  forbidden,
  unknown,
}

export type Remix = {
  revisionId: number;
  parentRevisionId: number;
  rootRevisionId: number;
  fileId: number;
  parentFileId: number;
  rootFileId: number;
  fileNameSlug: string;
};

export type CreateRemixResponse = {
  error?: CreateRemixError;
  remix?: Remix;
};

export type OwnerRemix = {
  fileId: number;
  created: string;
  name: string;
  thumbnail: string | null;
};
